import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, catchError, of } from 'rxjs';
import { ServiceConstant } from '../utils/service-constant.util';

@Injectable({
  providedIn: 'root',
})
export class PromotionService {
  httpClient = inject(HttpClient);
  constructor() {}

  getAllPromotions(): Observable<any> {
    return this.httpClient.get(ServiceConstant.apiUrl + `/restaurants/promotions`).pipe(
      catchError((error) => {
        console.error('Get current restaurant all promotions:', error);
        return of(error);
      }),
    );
  }

  createNewPromotion(promotion: any): Observable<any> {
    return this.httpClient.post(ServiceConstant.apiUrl + `/restaurants/promotions`, promotion).pipe(
      catchError((error) => {
        console.error('Create New Promotion:', error);
        return of(error);
      }),
    );
  }

  editPromotion(staff: any, id: any): Observable<any> {
    return this.httpClient
      .patch(ServiceConstant.apiUrl + `/restaurants/promotions/` + id, staff)
      .pipe(
        catchError((error) => {
          console.error('edit existing promotion:', error);
          return of(error);
        }),
      );
  }
}
